export function snapToNearest(value: number, possibleSizes: number[]): number {
  "worklet";
  if (possibleSizes.length === 0) {
    throw Error(
      `Possible sizes required to snapToNearest value: ${value} possibleSizes: ${JSON.stringify(
        possibleSizes
      )}`
    );
  }
  return possibleSizes.sort(
    (a, b) => Math.abs(a - value) - Math.abs(b - value)
  )[0];
}
